// libs
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';
import { showLoader, hideLoader } from 'redux/common/loader/loader.actions';
import { BreadCrumb, Timeline } from 'components';

import './createPaymentGatewayCredentials.scss';
import { onboardingProcessPGEdit } from './constants';
import { last } from 'lodash';
import { fetchPaymentGatewayCredentialDataRequest , resetPaymentGatewayCredentialEditDataOnCreateFormData} from './redux/paymentGatewayCredentials.actions';

const getDraftData = (draftData, sectionType) => {
    const filteredData =
        draftData &&
        draftData.length &&
        draftData.find(section => section.type === sectionType);
    return filteredData;
};

const EditPaymentGatewayCredentials = ({
    isEditMode,
    paymentGatewayCredentialsData,
    isViewMode,
    actions,
}) => {
    const history = useHistory();
    const { location } = history;
    const formIdentifier = last(location.pathname.split('/'));
    const { draftData, editFormData } = paymentGatewayCredentialsData;
    const [onBoardSteps, setOnBoardSteps] = useState(onboardingProcessPGEdit(isViewMode, formIdentifier, draftData));
    const [pgpageHeading, setPGPageheading] = useState("");

    useEffect(() => {
        if(isViewMode){
            setPGPageheading("View Payment Gateway Credentials")
        }
        else{
            setPGPageheading("Edit Payment Gateway Credentials")
        }
    }, [isViewMode])

    useEffect(() => {
        actions.showLoader();
    }, []);

    useEffect(() => {
        setOnBoardSteps(onboardingProcessPGEdit(isViewMode, formIdentifier, draftData));
    }, [draftData]);

    useEffect(() => {
            //actions.showLoader();
            // fetch api to get detials and populate draftData
            actions.fetchPaymentGatewayCredentialDataRequest({
                pgMidReferenceId: parseInt(formIdentifier),
            });
    
    }, [formIdentifier]);

    useEffect(() =>{
        actions.resetPaymentGatewayCredentialEditDataOnCreateFormData();
    }, [actions])

    // useEffect(() => {
    //     console.log("editFormData", editFormData);
    //     // Listen for changes in paymentGatewayCredentialsData to hide loader on success
    //     if (editFormData.isSuccess) {
    //         //actions.hideLoader(); // Hide loader on successful data fetch
    //     }
    // }, [editFormData.isSuccess]);

    return (
        <div
            className="create-pg-credentials-container"
            id="create-pg-credentials-container"
        >
            <div className="bread-crumbs">
              <h3>{pgpageHeading}</h3>

                <BreadCrumb
                    breadCrumbs={[
                        {
                            name: 'Payment Gateway Credentails',
                            link: '/payment-gateway-credentials',
                        },
                        {
                            name: `${pgpageHeading}`,
                            link: '',
                        },
                    ]}
                />
            </div>
            <div className="create-pg-credentials">
                <div className="left-section">
                    <Timeline
                        onboardingProcess={onBoardSteps}
                        isCreate={false}
                    />
                </div>
                <div className="right-section">
                    {onBoardSteps.map(tab => (
                        <Route exact path={tab.path} key={tab.tabId}>
                            {tab.component({
                                ...tab,
                                draftData: getDraftData(
                                    draftData,
                                    tab.sectionType
                                ),
                                onBoardSteps,
                                isEditMode,
                                isViewMode,
                                formIdentifier,
                            })}
                        </Route>
                    ))}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ loader, paymentGatewayCredentialsData }) => ({
    loader,
    paymentGatewayCredentialsData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchPaymentGatewayCredentialDataRequest,
            resetPaymentGatewayCredentialEditDataOnCreateFormData,
            showLoader,
            hideLoader
        },
        dispatch
    ),
});

EditPaymentGatewayCredentials.propTypes = {
    data: PropTypes.object.isRequired,
    actions: PropTypes.object,
    draftData: PropTypes.array,
    history: PropTypes.object,
    permissions: PropTypes.object,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditPaymentGatewayCredentials);
